export default "__VITE_ASSET__d9b905ca__"